import styled from 'styled-components';
// import devices from '~/styles/configs/devices';

export const Container = styled.div`
  height: 100%;
`;
